// extracted by mini-css-extract-plugin
module.exports = {"number-field":"sitemap_number-field__N67CW"};